import { create } from 'zustand';

// Port of src/app/services/mobile-device.service.ts.
// Angular used CDK BreakpointObserver on '(max-width: 639px)' and
// '(max-width: 767px)'; here window.matchMedia listeners are wired up by
// initDeviceStore(), which App must call once at startup (replicates the
// Angular constructor subscription).
interface DeviceState {
  isMobileDevice: boolean;
  isMaxTabletDevice: boolean;
}

export const useDeviceStore = create<DeviceState>()(() => ({
  isMobileDevice: false,
  isMaxTabletDevice: false,
}));

let initialized = false;

export function initDeviceStore(): () => void {
  if (initialized) {
    return () => {};
  }
  initialized = true;

  const mobileQuery = window.matchMedia('(max-width: 639px)');
  const tabletQuery = window.matchMedia('(max-width: 767px)');

  const onMobileChange = (e: MediaQueryListEvent | MediaQueryList) =>
    useDeviceStore.setState({ isMobileDevice: e.matches });
  const onTabletChange = (e: MediaQueryListEvent | MediaQueryList) =>
    useDeviceStore.setState({ isMaxTabletDevice: e.matches });

  // BreakpointObserver emits the current state immediately on subscribe.
  onMobileChange(mobileQuery);
  onTabletChange(tabletQuery);

  mobileQuery.addEventListener('change', onMobileChange);
  tabletQuery.addEventListener('change', onTabletChange);

  return () => {
    mobileQuery.removeEventListener('change', onMobileChange);
    tabletQuery.removeEventListener('change', onTabletChange);
    initialized = false;
  };
}
